function checkPlugin(comp) {
  const fallbackDomain = "http://127.0.0.1:19750/";
  // let triedFallback = false;
  return new Promise((resolve, reject) => {
    let xmlhttp;
    let response = "";
    // code for IE7+, Firefox, Chrome, Opera, Safari
    if (window.XMLHttpRequest) {
      xmlhttp = new XMLHttpRequest();
    } else {
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
        response = xmlhttp.responseText;
        process = false;
        if (response != "") {
          comp.errorInitPlugin = false;
          comp.errorStatus = null;
          comp.blockUI.stop();
          // initPluginSign(comp);
          // selectedCertificate(comp);
          resolve(true);
        }
        if (response == "") {
          comp.errorInitPlugin = true;
          comp.showErrMsgTransleFormat("messages.initPlugin_faile");
          reject("messages.initPlugin_faile");
          comp.blockUI.stop();
        }
      }

      if (xmlhttp.readyState == 4 && xmlhttp.status == 0) {
        // if (response == "") {
        //   comp.errorInitPlugin = true;
        //   comp.showErrMsgTransleFormat("messages.initPlugin_faile");
        //   reject("messages.initPlugin_faile");
        //   comp.blockUI.stop();
        // }
        if (!triedFallback) {
          triedFallback = true;
          domain = fallbackDomain;
          console.warn("Retrying with fallback domain:", domain);
          checkPlugin(comp);
        } else {
          comp.errorInitPlugin = true;
          comp.showErrMsgTransleFormat("messages.initPlugin_faile");
          reject("messages.initPlugin_faile");
          comp.blockUI.stop();
        }
      }
    };
    xmlhttp.open("POST", domain + "getSession", true);
    xmlhttp.send();
  });
}

function initPlugin(comp) {
  let xmlhttp;
  let response = "";
  // code for IE7+, Firefox, Chrome, Opera, Safari
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  } else {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }
  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
      response = xmlhttp.responseText;
      process = false;
      if (response != "") {
        comp.errorInitPlugin = false;
        comp.errorStatus = null;
        comp.blockUI.stop();
        initPluginSign(comp);
        // selectedCertificate(comp);
        return;
      }
      if (response == "") {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransleFormat("messages.initPlugin_faile");
        return;
      }
    }

    if (xmlhttp.readyState == 4 && xmlhttp.status == 0) {
      if (response == "") {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransleFormat("messages.initPlugin_faile");
        return;
      }
    }
  };
  xmlhttp.open("POST", domain + "getSession", true);
  xmlhttp.send();
  // setTimeout(initPlugin, 0);
}

function showErrorMessage(comp, message) {
  if (VtPluginSocket) {
    const errorCode = VtPluginSocket.getLastErrorCode();
    if (errorCode) {
      const errorMessage = VtPluginSocket.ERROR_CODE[errorCode];
      if (!errorMessage) {
        if (!message) {
          comp.showErrMsg("Lỗi" + errorMessage + "(" + errorCode + ")");
        } else {
          comp.showErrMsg(message);
        }

        return;
      }
    }
    comp.showErrMsgTransleFormat("messages.initPlugin_faile");
  } else {
    comp.showErrMsgTransleFormat("messages.initPlugin_faile");
  }
}

/**
 * Init plugin of VTS again
 * @param {*} comp component SignDocumentComponent
 */
function initPluginSign(comp) {
  if (VtPluginSocket) {
    if (VtPluginSocket.initPlugin()) {
      signUSB(comp);
      return true;
    } else {
      comp.showErrMsgTransleFormat("messages.initPlugin_faile");
    }
  } else {
    comp.showErrMsgTransleFormat("messages.initPlugin_faile");
  }
  return false;
}

function getSessionId() {
  if (VtPluginSocket) {
    var sessionId = VtPluginSocket.getSessionId();
    return sessionId;
  }
}

function signUSB(comp) {
  //Bước 1. Lấy CTS mà người dùng chọn
  const certUserBase641 = VtPluginSocket.getCert();
  if (!certUserBase641) {
    comp.showErrMsgTransle("messages.select_certificate_failed");
    return false;
  }

  /**
   * Check certificate selected and certificate selecting
   */
  comp.createHash(certUserBase641);
}

function anonymousSignUSB(comp, certUserBase64) {
  if (!certUserBase64) {
    comp.showErrMsgTransle("messages.select_certificate_failed");
    return false;
  }
  /**
   * Check certificate selected and certificate selecting
   */
  comp.createHash(certUserBase64);
}

function anonymousSignHash(comp, hashBase64, sessionId, serialNumber) {
  if (!VtPluginSocket) {
    comp.blockUI.stop();
    comp.showErrMsgTransleFormat("messages.initPlugin_faile");
    return;
  }
  if (!sessionId) {
    if (!initPlugin(comp)) {
      return;
    }
  }
  //Bước 3. Sau khi nhận mã Hash từ Server, gọi Plugin ký mã Hash này để thu được Chữ ký Signature
  const signatureBase641 = VtPluginSocket.anonymousSignHash(
    hashBase64,
    sessionId,
    serialNumber
  );
  comp.blockUI.stop();
  return signatureBase641;
}

function normalSignHash(comp, hashBase64, sessionId, serialNumber) {
  if (!VtPluginSocket) {
    comp.blockUI.stop();
    comp.showErrMsgTransleFormat("messages.initPlugin_faile");
    return;
  }
  if (!sessionId) {
    if (!initPlugin(comp)) {
      return;
    }
  }
  //Bước 3. Sau khi nhận mã Hash từ Server, gọi Plugin ký mã Hash này để thu được Chữ ký Signature
  const signatureBase641 = VtPluginSocket.anonymousSignHash(
    hashBase64,
    sessionId,
    serialNumber
  );
  comp.blockUI.stop();
  comp.signUsbNormal(signatureBase641);
  // return signatureBase641;
}

function signHash(comp, hashBase641) {
  if (!VtPluginSocket) {
    comp.blockUI.stop();
    comp.showErrMsgTransleFormat("messages.initPlugin_faile");
    return;
  }
  if (!VtPluginSocket.hSession) {
    if (!initPlugin()) {
      return;
    }
  }
  //Bước 3. Sau khi nhận mã Hash từ Server, gọi Plugin ký mã Hash này để thu được Chữ ký Signature
  const signatureBase641 = VtPluginSocket.signHash(hashBase641);
  comp.blockUI.stop();
  return signatureBase641;
}

function getCertInUsb(comp) {
  if (VtPluginSocket) {
    var cert = VtPluginSocket.getCertinUsb(comp);
    comp.blockUI.stop();
    return cert;
  }
}
